import { useEffect, useState } from "react";
import Cookies from "universal-cookie";
import { Box, CircularProgress, Typography } from "@mui/material";

/**
 * Landing page for the Microsoft ("Login Corporativo") flow.
 *
 * mw-auth sets the `accessToken` / `refreshToken` cookies on the shared parent
 * domain before redirecting here, so no token is read from the URL. This page only
 * checks that the session cookie is present and forwards the user to the
 * application they asked for (the `url` parameter round-tripped by the login).
 */
export const MicrosoftCallbackPage: React.FC = () => {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const cookies = new Cookies();
    if (!cookies.get("accessToken")) {
      setError("Não foi possível concluir o login corporativo. Tente novamente.");
      return;
    }

    const url = new URLSearchParams(window.location.search).get("url");
    if (!url) {
      setError("Não foi possível determinar a URL de redirecionamento.");
      return;
    }

    window.location.href = url;
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        gap: 3,
      }}
    >
      {error ? (
        <Typography color="error" sx={{ fontSize: "1.6rem", textAlign: "center", px: 4 }}>
          {error}
        </Typography>
      ) : (
        <>
          <CircularProgress />
          <Typography sx={{ fontSize: "1.6rem" }}>
            Concluindo login corporativo...
          </Typography>
        </>
      )}
    </Box>
  );
};

export default MicrosoftCallbackPage;
